// extracted by mini-css-extract-plugin
export var avatarContainer = "_3i-0";
export var largeAvatarContainer = "_3i-1";